import { createContext, useContext, useState } from "react";

const BookingContext = createContext(null);

export const BookingProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  const [treatment, setTreatment] = useState("");

  const book = (t = "") => {
    setTreatment(t);
    setOpen(true);
  };

  return (
    <BookingContext.Provider value={{ open, setOpen, treatment, book }}>
      {children}
    </BookingContext.Provider>
  );
};

export const useBooking = () => useContext(BookingContext);
